import React from "react";

import { useIntegrationUpload } from "../hooks/use-integration-upload";
import type { IIntegrationHandoffBridgeProps } from "../types";

// NOTE: NSAI-7067 — the connector hand-off ("downloaded" → "uploading") as a
// component, so it can be mounted wherever the attachment store it reads lives.
// Two mounts, matching mobile's (NSAI-5241):
//   - TransferProvider mounts it above the routes, inside the store the
//     Uploads page's MANAGED picker writes into — which is what lets a fetch
//     outlive that page;
//   - a LOCAL picker (the probe and presentation-theme modals) mounts it next
//     to its own store, so its picks stay with its own uploader.
// A component rather than a hook call because `useIntegrationUpload` reads the
// chat context, which has to be provided one level above the hook — and
// because a picker chooses its arm at render time, where a hook cannot be
// called conditionally.
const IntegrationHandoffBridgeComponent = (
  props: IIntegrationHandoffBridgeProps,
): null => {
  useIntegrationUpload(props);

  return null;
};

export const IntegrationHandoffBridge = React.memo(
  IntegrationHandoffBridgeComponent,
);

IntegrationHandoffBridge.displayName = "IntegrationHandoffBridge";
